export {DraggableArea, DraggableAreasGroup} from 'react-draggable-tags';


// WEBPACK FOOTER //
// ./src/yxyweb/common/components/dimension-setting/Draggable.js